// src/metaConfig.js
export const getMetaByCountry = (countryCode) => {
  const meta = {
    IN: {
      title: "Shop Premium USA Brands Online in India at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in India from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    SA: {
      title: "Shop Premium USA Brands Online in Saudi Arabia at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in Saudi Arabia from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    AE: {
      title: "Shop Premium USA Brands Online in UAE at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in UAE from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    KW: {
      title: "Shop Premium USA Brands Online in Kuwait at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in Kuwait from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    UK: {
      title: "Shop Premium USA Brands Online in United Kingdom at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in United Kingdom from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    GB: {
      title: "Shop Premium USA Brands Online in United Kingdom at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in United Kingdom from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    OM: {
      title: "Shop Premium USA Brands Online in Oman at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in Oman from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    US: {
      title: "Shop Premium USA Brands Online in USA at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in USA from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    BH: {
      title: "Shop Premium USA Brands Online in Bahrain at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in Bahrain from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    QA: {
      title: "Shop Premium USA Brands Online in Qatar at Global Genie &ndash; TheGlobalGenie",
      description: 'Buy online Premium USA Brands in Qatar from Global Genie with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
  };

  return meta[countryCode] || meta["IN"]; // fallback to AE
};
